import Bills from "./Bills";
export default function RecurringBills() {
    return <Bills docType="recurring_bill" title="Recurring Bills" kicker="PURCHASES" subtitle="Automated bills for rent, subscriptions, and retainers." />;
}
